<script>
// Kendi Android telefonunu SMS hatti olarak baglama ekrani.
//
// NEDEN burada kimlik bilgisi sorulmuyor: baglanti QR ile kuruluyor.
// Kutu olusturulduktan sonra "SMS cihazi" sekmesinde QR uretiliyor ve
// telefon okutuyor. Burada sorulan tek sey hattin numarasi ve kutu adi.
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';

import NextButton from 'dashboard/components-next/button/Button.vue';

const artiIleBaslamali = (deger = '') => deger.startsWith('+');

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      kutuAdi: '',
      telefon: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    kutuAdi: { required },
    telefon: { required, artiIleBaslamali },
  },
  methods: {
    async kanalOlustur() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      try {
        const kanal = await this.$store.dispatch('inboxes/createChannel', {
          name: this.kutuAdi?.trim(),
          channel: {
            type: 'sms',
            phone_number: this.telefon,
            // Saglayici: mesaj disariya HTTP ile degil, eslesmis telefonun
            // kuyruguna yaziliyor.
            provider: 'omnup_android',
            provider_config: {},
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: kanal.id },
        });
      } catch (e) {
        useAlert(
          e?.response?.data?.message || this.$t('INBOX_MGMT.ADD.SMS.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap mx-0" @submit.prevent="kanalOlustur">
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-full">
      <label :class="{ error: v$.kutuAdi.$error }">
        {{ $t('INBOX_MGMT.ADD.OMNUP_SMS.AD') }}
        <input
          v-model="kutuAdi"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.OMNUP_SMS.AD_YER')"
          @blur="v$.kutuAdi.$touch"
        />
        <span v-if="v$.kutuAdi.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.OMNUP_SMS.AD_HATA') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-full">
      <label :class="{ error: v$.telefon.$error }">
        {{ $t('INBOX_MGMT.ADD.OMNUP_SMS.TELEFON') }}
        <input
          v-model="telefon"
          type="text"
          placeholder="+905551112233"
          @blur="v$.telefon.$touch"
        />
        <span v-if="v$.telefon.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.OMNUP_SMS.TELEFON_HATA') }}
        </span>
      </label>
    </div>

    <div
      class="w-[65%] flex-shrink-0 flex-grow-0 max-w-full p-4 mb-4 border rounded-lg border-n-weak bg-n-alpha-1"
    >
      <p class="text-sm text-n-slate-12">
        {{ $t('INBOX_MGMT.ADD.OMNUP_SMS.BILGI') }}
      </p>
    </div>

    <div class="w-full">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        :label="$t('INBOX_MGMT.ADD.OMNUP_SMS.OLUSTUR')"
      />
    </div>
  </form>
</template>
